module.exports = {"TXTWCL_Today":{"id":"TXTWCL_Today","defaultMessage":"Hoje"},"TXTWCL_Tomorrow":{"id":"TXTWCL_Tomorrow","defaultMessage":"Amanhã"}}